import { useState as s, useMemo as g, useEffect as D } from "react";
import { VODProviderType as i } from "../../models/VODProviderType.js";
import E from "../../helpers/getPoyanVideoInfo.js";
import R from "../../helpers/getAbrHamrahiVideoInfo.js";
const I = ({ provider: o, hlsUrl: t, children: k, providerUrl: d }) => {
  const [b, A] = s(!1), [u, n] = s(null), [f, c] = s({
    mobile: null,
    desktop: null
  }), r = g(() => o === i.STANDARD ? t : u, [o, u, t]), [p, a] = s(!r), y = (l) => {
    l.name !== "AbortError" && A(!0), a(!1), n(null);
  }, H = () => {
    p || a(!0), b && A(!1), u !== null && n(null), (f.mobile || f.desktop) && c({
      desktop: null,
      mobile: null
    });
  };
  D(() => {
    if (o === i.STANDARD || !t) return () => {
    };
    const l = new AbortController();
    switch (H(), o) {
      case i.POUAN:
        E(t, d, l.signal).then((e) => {
          var P;
          a(!1), n(e.data.play_data.play_url);
          const m = (P = e.data.play_data.thumbnails) == null ? void 0 : P.at(0);
          m && c({
            desktop: m.url,
            mobile: m.url
          });
        }).catch(y);
        return;
      case i.ABR_HAMRAHI:
        R(t, d, l.signal).then((e) => {
          a(!1), n(e.stream_link), c({
            desktop: e.vtt || null,
            mobile: e.vtt_mobile || null
          });
        }).catch(y);
    }
    return () => {
      l.abort();
    };
  }, [o, t]);
  const _ = g(() => {
    if (r)
      return [{ src: r }];
  }, [r]);
  return k({
    hasError: b,
    isLoading: p,
    playUrl: r,
    sources: _,
    vtt: f
  });
};
export {
  I as default
};
